import { render, staticRenderFns } from "./AnnouncementNotification.vue?vue&type=template&id=14fc5fe1&"
import script from "./AnnouncementNotification.vue?vue&type=script&lang=js&"
export * from "./AnnouncementNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports